import "./index.scss";
import React, { FunctionComponent, useEffect, ReactNode, useState } from "react";
import routes from "../../routing/routes";
import { Publisher } from "../../containers/Wizard"
import { API_HOST } from "../../config";

const fetchStep = (pathname: string) =>
  routes.find((r) => r.path === pathname)?.step || 0;

type LayoutProps = {
  pathname: string;
  authenticate: Function;
  cancelWizard: Function;
  children: ReactNode,
  publisher: Publisher
};
const Layout: FunctionComponent<LayoutProps> = ({
  pathname,
  authenticate,
  cancelWizard,
  children,
  publisher,
}: LayoutProps) => {
  const [openMainMenu, setOpenMainMenu] = useState(false)
  useEffect(() => {
    authenticate();
  }, [authenticate]);
  const step = fetchStep(pathname);
  const progress = (step / 22) * 100;

  const toggleMainMenu = () => {
    setOpenMainMenu(!openMainMenu)
  }

  const confirmReset = () => {
    const reset = window.confirm("Are you sure you want to stop building your display ad?");
    if (reset) {
      cancelWizard();
    }
  };

  const [display, setDisplay] = useState({});
  useEffect(() => {
    fetch(`${API_HOST}/adblock`)
    .then(res => res.json())
    .then(
      (result) => {
        setDisplay({display: "none"});
      },
      (error) => {
        setDisplay({});
      }
    )
  }, [])

  return (
    <div className={`App ${openMainMenu ? "nav-active" : ""}`} data-current-step={step}>
    <div className="blocker-banner" id="blocker-banner" style={display}>
      <div className="blocker-banner-interior">
        <span className="icon mdi mdi-alert"></span>
        <div className="blocker-banner-title">We notice you're using an ad blocker.</div>
        <div className="blocker-banner-text">Since the purpose of this site is to display digital ads, please disable your ad blocker to prevent content from breaking.</div>
        
      </div>
    </div>
      <div className="header">
        <div className="header-main">
          <div className="container">
            <a className="logo" href="/"><img src={publisher?.cdn_logo_url} alt="logo"/></a>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a className="mdi main-nav-item mdi-menu" onClick={toggleMainMenu}>{""}</a>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a className="mdi main-nav-item mdi-close" onClick={confirmReset} title="Close Ad Builder">{""}</a>
            <ul className="nav">
              <li><a href="/"><span className="mdi mdi-home"></span><span>Directory Home</span></a></li>
              <li><a href="/promote/"><span className="mdi mdi-plus"></span><span>Add Business</span></a></li>
              <li><a href="/offers/"><span className="mdi mdi-picture-in-picture-top-right"></span><span>Offers</span></a></li>
              <li><a href="/ads/"><span className="mdi mdi-newspaper"></span><span>Print Ads</span></a></li>
              <li><a href="/categories/"><span className="mdi mdi-layers-outline"></span><span>Categories</span></a></li>
              <li><a href={publisher?.newspaper_url}><span className="mdi mdi-home-outline"></span><span>{publisher?.newspaper_name}</span></a></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="wizard">
        <div className="table-cell">
          <div className="step">{children}</div>
        </div>
      </div>
      {step !== 23 && <div className="progress-wrapper">
        <div className="progress">
          <div className="progress-bar" style={{ width: `${progress}%` }}></div>
        </div>
      </div>}
      <div className="confetti"></div>
    </div>
  );
};

export default Layout;
